import React, {Component} from 'react';
import PropTypes from 'prop-types'
import template from '../../templates/Pager.rt';

// replace with this https://github.com/infusion/jQuery-Paging

const firstActivePages = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

const createActivePages = (firstPage, lastPage, totalPages) => {
  if (lastPage > totalPages) {
    return getLastActivePages(totalPages);
  }

  if (firstPage < 9) {
    return firstActivePages;
  }

  const activePages = [];
  for (let i = firstPage; i <= lastPage; i++) {
    activePages.push(i);
  }

  return activePages;
};

const getActivePages = (page) => {
  if (page > 9) {
    const activePages = [];
    for (let i = page - 5; i < page + 5; i++) {
      activePages.push(i);
    }
    return activePages;
  } else {
    return firstActivePages;
  }
};

const getLastActivePages = (totalPages) => {
  const activePages = [];
  for (let i = totalPages - 8; i < totalPages + 2; i++) {
    activePages.push(i);
  }
  return activePages;
};

const generatePages = (totalPages) => {
  const activePages = [];
  for (let i = 1; i < totalPages + 1; i++) {
    activePages.push(i);
  }

  return activePages;
}

export default class PagerContent extends Component {
  static propTypes = {
    totalPages: PropTypes.number.isRequired,
    pageClick: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired
  }

  constructor(props) {
    super(props);
    this.state = {
      activePage: 1,
      activePages: generatePages(Math.min(props.totalPages, 10))
    }
  }

  componentWillReceiveProps(nextProps) {
    // console.log(333, nextProps);
    if (nextProps.totalPages !== 0 && this.state.activePage !== nextProps.page) {
      const lastActivePage = this.state.activePages[this.state.activePages.length - 1];
      this.setState({
        // activePages: lastActivePage
        //   ? createActivePages(lastActivePage, lastActivePage + 9, nextProps.totalPages)
        //   : firstActivePages
        activePage: nextProps.page + 1,
        activePages: lastActivePage ? this.state.activePages : firstActivePages
      })
    }
  }

  handleFirstPageClick = () => {
    if (this.state.activePage === 1) return;
    this.setState({
      activePage: 1,
      activePages: firstActivePages
    });
    this.props.pageClick(1);
  };

  handleLastPageClick = () => {
    const {totalPages} = this.props;
    if (this.state.activePage === totalPages) return;
    const lastActivePage = this.state.activePages[this.state.activePages.length - 1];
    if (totalPages - lastActivePage < 9) {
      this.setState({
        activePage: totalPages,
        activePages: this.state.activePages
      });
      this.props.pageClick(totalPages);
    } else {
      this.setState({
        activePage: totalPages,
        activePages: getLastActivePages(totalPages)
      });
      this.props.pageClick(totalPages);
    }
  };

  handleNextPageClick = () => {
    const lastActivePage = this.state.activePages[this.state.activePages.length - 1];
    const {totalPages} = this.props;
    this.setState({
      activePage: lastActivePage,
      activePages: createActivePages(lastActivePage, lastActivePage + 9, totalPages)
    });
    this.props.pageClick(lastActivePage);
  };

  handlePreviousPageClick = () => {
    const firstActivePage = this.state.activePages[0];
    const {totalPages} = this.props;
    this.setState({
      activePage: firstActivePage,
      activePages: createActivePages(firstActivePage - 9, firstActivePage, totalPages)
    });
    this.props.pageClick(firstActivePage);
  };

  handlePageClick = (page, pageIndex) => {
    if (pageIndex === 9) { // click last page in a sequence
      if (this.props.totalPages - page < 10) {
        this.setState({
          activePage: page,
          activePages: createActivePages(page, page + 9, this.props.totalPages)
        });
        this.props.pageClick(page);
      } else if (this.props.totalPages - page > 10) {
        const lastVisiblePage = this.state.activePages[9];
        this.setState({
          activePage: lastVisiblePage,
          activePages: getActivePages(lastVisiblePage)
        });
        this.props.pageClick(lastVisiblePage);
      } else {
        this.setState({
          activePage: page,
          activePages: getLastActivePages(this.props.totalPages - 1)
        });
        this.props.pageClick(page);
      }
    } else if (pageIndex === 0) { // click first page in a sequence
      this.setState({
        activePage: page,
        activePages: getActivePages(page)
      });
      this.props.pageClick(page);
    } else {
      this.setState({activePage: page});
      this.props.pageClick(page);
    }
  };

  render = template
}

